"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRoutePath = void 0;
var react_router_dom_1 = require("react-router-dom");
/**
 * @TODO: workout how to make params (second argument) required when the path has dynamic params and never when it does not
 */
var generateRoutePath = function (path, params) {
    return (0, react_router_dom_1.generatePath)(path, params);
};
exports.generateRoutePath = generateRoutePath;
